import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { ScheduledGlobalAlert } from "../../models/globalalert";

@Component({
  selector: "app-globalalert-delete-modal",
  templateUrl: "../templates/globalAlertDeleteModal.component.html",
})
export class GlobalAlertDeleteModalComponent {
  @Output() itemDeleted: EventEmitter<ScheduledGlobalAlert> =
    new EventEmitter<ScheduledGlobalAlert>();

  private message: ScheduledGlobalAlert;

  constructor(
    private dialogRef: MatDialogRef<GlobalAlertDeleteModalComponent>,
    private scheduleService: ScheduleService,
    @Inject(MAT_DIALOG_DATA)
    private _data: {
      message: ScheduledGlobalAlert;
    }
  ) {
    this.message = this._data.message;
  }

  async accept() {
    if (this.message) {
      const result = this.handleDeleteMessage();

      if (result) {
        this.itemDeleted.emit(this.message);
      }
    }

    this.close();
  }

  close() {
    this.dialogRef.close();
  }

  private async handleDeleteMessage() {
    const result = await this.scheduleService
      .DeleteScheduled(this.message.id)
      .toPromise();

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/components/scripts/globalAlertDeleteModal.component.ts